/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_View_TransitionsInputs */

const en_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View transitions`)
};

const ar_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتقالات العرض`)
};

const bn_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভিউ ট্রানজিশন`)
};

const de_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergänge anzeigen`)
};

const es_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver transiciones`)
};

const fr_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les transitions`)
};

const pt_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver transições`)
};

const zh_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视图转换`)
};

const tr_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçişleri görüntüle`)
};

const ru_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотр переходов`)
};

const pl_svchip_view_transitions = /** @type {(inputs: Svchip_View_TransitionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyświetl przejścia`)
};

/**
* | output |
* | --- |
* | "View transitions" |
*
* @param {Svchip_View_TransitionsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_view_transitions = /** @type {((inputs?: Svchip_View_TransitionsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_View_TransitionsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_view_transitions(inputs)
	if (locale === "bn") return bn_svchip_view_transitions(inputs)
	if (locale === "de") return de_svchip_view_transitions(inputs)
	if (locale === "es") return es_svchip_view_transitions(inputs)
	if (locale === "fr") return fr_svchip_view_transitions(inputs)
	if (locale === "pt") return pt_svchip_view_transitions(inputs)
	if (locale === "zh") return zh_svchip_view_transitions(inputs)
	if (locale === "tr") return tr_svchip_view_transitions(inputs)
	if (locale === "ru") return ru_svchip_view_transitions(inputs)
	if (locale === "pl") return pl_svchip_view_transitions(inputs)
	return en_svchip_view_transitions(inputs)
});